import { getReportSaveMode } from "@mcapps/shared/reportAppConstants";
import { IReport } from "@mctypes/report.types";
import { SafeParseReturnType } from "zod";
import { apiSlice } from "../../../apiSlice";
import { ReportCode } from "@mcapps/shared/reportSchemas/reportSchemas";
import { getLatestVersionOfReport, setEditedDataInRedux } from "./reportSlice";

export const reportRTK = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getReportBoards: builder.query<IReport.IReportBoardPopulated[], { projectId: string; filter?: string }>({
      query: (input) => ({
        url: `/project/${input.projectId}/reportboard/reportboards.get`,
        method: "POST",
        body: input.filter != null ? { filter: input.filter } : {},
      }),
    }),
    getSingleReportBoard: builder.query<IReport.IReportBoardPopulated, { projectId: string; reportBoardId: string }>({
      query: (input) => ({
        url: `/project/${input.projectId}/reportboard/singlereportboard.get`,
        method: "POST",
        body: { reportBoardId: input.reportBoardId },
      }),
      providesTags: ["SingleReportBoard"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (getReportSaveMode(data.template) === "direct") return;
          const latestVersion = getLatestVersionOfReport(data);
          dispatch(setEditedDataInRedux({ code: data.template as ReportCode, data: latestVersion?.data as any }));
        } catch (err) {
          console.error("Failed to fetch single report board:", err);
        }
      },
    }),
    getReportZodErrors: builder.query<
      SafeParseReturnType<any, any>,
      { projectId: string; templateId: number; reportData: object }
    >({
      query: (input) => ({
        url: `/project/${input.projectId}/reportboard/${input.templateId}/errors`,
        method: "POST",
        body: { reportData: input.reportData },
      }),
    }),
  }),
});

export const { useGetReportBoardsQuery, useGetSingleReportBoardQuery, useGetReportZodErrorsQuery } = reportRTK;

export const getReportZodErrors = async (
  projectId: string,
  templateId: number,
  reportData: object,
): Promise<SafeParseReturnType<any, any>> => {
  try {
    const response = await fetch(`/api/project/${projectId}/reportboard/${templateId}/errors`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ reportData }),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status} ${response.statusText}`);
    }

    const zodResult: SafeParseReturnType<any, any> = await response.json();
    return zodResult;
  } catch (error) {
    console.error("Error fetching Zod errors:", error);
    throw error;
  }
};
